import { store } from "../../../../src/store";

const getMap = () => store.getState().pages.truterritory.map;

angular.module("modules:mapping").factory("ContextMenu", function ($rootScope, $http, $compile, $window, $stateParams, $q, API_ROOT, $timeout) {
  return {
    /**
     * Create an instance of L.ContextMenu
     * @param {function} getMap
     * @param {function} findCollection A function to find a collection by ID
     * @param {bool} isPublicPage
     * @param  {L.LatLng} latlng
     * @param {TruMap} truMap
     * @return {Promise}
     */
    make(findCollection, isPublicPage, searchText, latlng, truMap, customOptions = []) {
      const infoReq = $http.get(makeInfoURL(truMap, latlng), { withCredentials: false }).then(resp => resp.data.data);
      const reportsReq = !isPublicPage && getMap().ID
                          ? $http.get(makeVisibleReportsURL(getMap(), latlng)).then(resp => resp.data.data)
                          : Promise.resolve([]);

      return Promise.all([infoReq, reportsReq]).then(function ([features, reports]) {
        let sections = makeMenuSections(features, reports, getMap(), findCollection, isPublicPage, searchText, truMap, customOptions);
        return new L.ContextMenu(latlng, $compile, sections, $rootScope);
      });
    },

    /**
     * Create an instance of L.ContextMenu, but don't look for intersecting features
     * @param  {function}  getMap
     * @param  {Boolean} isPublicPage
     * @param  {L.LatLn}  latlng
     * @param  {TruMap}  truMap
     * @return {Promise}
     */
    makeWithoutFeatures(getMap, isPublicPage, searchText, latlng, truMap, customOptions = []) {
      let sections = makeMenuSections(false, false, getMap(), null, isPublicPage, searchText, truMap, customOptions),
        menu = new L.ContextMenu(latlng, $compile, sections, $rootScope);
      return $q.when(menu);
    },
  };

  /**
   * Generate the URL for fetching information about a point
   * @param  {TruMap} truMap
   * @param  {L.LatLng} latlng
   * @return {string}
   */
  function makeInfoURL(truMap, latlng) {
    return truMap._tileUrl + "/info/" + truMap._tileLayerID + "/" + truMap._map.getZoom() + "/" + latlng.lat + "/" + latlng.lng;
  }

  /**
   * Generate the URL for fetching list of visible reports.
   */
  function makeVisibleReportsURL(map, latlng) {
    return `${API_ROOT}/mapping/reports/visible/${map.ID}/${latlng.lat}/${latlng.lng}?entityID=${$stateParams.entityID}`;
  }

  /**
   * Generate the content for the menu
   * @param  {array} features The array of features returned for the info request
   * @param {Object} map The map model
   * @param {function} findCollection
   * @param {bool} isPublicPage
   * @param {TruMap} truMap
   * @return {array}
   */
  function makeMenuSections(features, reports, map, findCollection, isPublicPage, searchText, truMap, customOptions = []) {
    let sections = [];

    if (features !== false) {
      sections.push({
        header: "Select layer:",
        items: features,
        onSelect: showFeatureProperties.bind(null, findCollection, isPublicPage),
      });
    }

    let options = {
      header: "Options:",
      items: angular.copy(customOptions),
      onSelect: null,
    };

    if (map.reportsEnabled && !isPublicPage) {
      options.items.push({
        name: "Download Site Report",
        onSelect: downloadSiteReport.bind(null, map, truMap, searchText),
      });
    }

    if (options.items && options.items.length) sections.push(options);

    if (reports && !isPublicPage) {
      let reportSection = {
        header: "Reports:",
        items: [],
        onSelect: null,
      };

      for (let report of reports) {
        reportSection.items.push({ name: report.label, onSelect: downloadMapReport.bind(null, report, truMap, searchText) });
      }

      if (reportSection.items.length) sections.push(reportSection);
    }

    return sections;
  }

  /**
   * Make a popup showing a feature's properties
   * @param {function} findCollection
   * @param {bool} isPublicPage
   * @param  {Object} feature
   * @param  {L.Map} map
   * @param  {L.LatLng} latlng
   * @return {void}
   */
  function showFeatureProperties(findCollection, isPublicPage, feature, map, latlng) {
    var popupScope = $rootScope.$new();
    popupScope.feature = feature;
    popupScope.map = map;
    popupScope.findCollection = findCollection;
    popupScope.editable = !isPublicPage;

    var el = $compile('<span map-point-detail feature="feature" map="map" find-collection="findCollection" editable="editable"></span>')(popupScope);
    el.css({ "max-height": map.getContainer().clientHeight * 0.8 - 52 });

    var popup = L.popup({ minWidth: "250", closeButton: false });
    $timeout(function () {
      popup.setLatLng(latlng).setContent(el.get(0)).openOn(map);
    });

    // Close the popup on opening another context menu.
    map.on("contextmenu", close);
    function close() {
      map.closePopup(popup);
      map.off("contextmenu", close);
    }
  }

  /**
   * Get a site report
   * @param  {Object} map     The map model
   * @param  {TruMap} truMap
   * @param  {string} searchText
   * @param  {Object} feature
   * @param  {void} _
   * @param  {L.LatLng} latlng
   * @return {void}
   */
  function downloadSiteReport(map, truMap, searchText, feature, _, latlng) {
    let url = `${API_ROOT}/mapping/maps/${map.ID}/reports/${truMap._tileLayerID}/${latlng.lat}/${latlng.lng}?entityID=${$stateParams.entityID}&address=${searchText}`;
    $window.open(url);
  }

  /**
   * Get a map report
   * @param  {Object} report  The mapReport model
   * @param  {TruMap} truMap
   * @param  {string} searchText
   * @param  {Object} feature
   * @param  {void} _
   * @param  {L.LatLng} latlng
   * @return {void}
   */
  function downloadMapReport(report, truMap, searchText, feature, _, latlng) {
    let url = `${API_ROOT}/mapping/reports/${report.ID}/${truMap._tileLayerID}/${latlng.lat}/${latlng.lng}?entityID=${$stateParams.entityID}&address=${searchText}&format=pdf`;
    $window.open(url);
  }
});
